import React from "react";

function Header() {
  return (
    <header>
      <h1>
        Word Game{" "}
        <small>
          by <a href="https://github.com/ter1203/wordle/">Terry</a>{" "}
        </small>
      </h1>
    </header>
  );
}

export default Header;
